import { render, staticRenderFns } from "./TasksAutocomplete.vue?vue&type=template&id=157b02e0&scoped=true&"
import script from "./TasksAutocomplete.vue?vue&type=script&lang=js&"
export * from "./TasksAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./TasksAutocomplete.vue?vue&type=style&index=0&id=157b02e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b02e0",
  null
  
)

export default component.exports